// useListenMasivoUser customHook

import { useMasivoRegister } from "@multicines/hooks";
import { MasivoRegisterHookPayload } from "@multicines/services";
import { useFetchMasivoInfo, useFetchUser } from "@multicines/services";
import { getTradeCodeApiError } from "@multicines/utils";
import { getApiMessageError } from "@multicines/utils";
import { useRouter } from "next/router";
import { useEffect } from "react";

import { useAuthStore } from "stores/auth/auth.store";
import { createErrorNotification } from "utils/notifications.utils";

const useListenMasivoUser = () => {
  const { asPath } = useRouter();
  const uid = useAuthStore(state => state.uid);
  const isAnonymous = useAuthStore(state => state.isAnonymous);
  const { data: user, isSuccess: isSuccessUser } = useFetchUser({
    uid,
    isAnonymous
  });
  // INFO: User is registered complete if is SuccessUser and pass second step screen
  const getIsRegisteredComplete = () => {
    if (!isSuccessUser) return false;
    if (!asPath) return false;

    const isSecondStep = asPath.startsWith("/signup-user");
    if (isSecondStep) return false;

    return true;
  };
  const isRegisteredComplete = getIsRegisteredComplete();
  const masivoInfoQuery = useFetchMasivoInfo({
    uid,
    isAnonymous,
    isRegisteredComplete
  });
  const { handleMasivoRegister } = useMasivoRegister({ isAnonymous, uid });

  const getUserNoRegisteredInMasivo = () => {
    const { error: masivoInfoError } = masivoInfoQuery;
    const { response } = masivoInfoError ?? {};
    const { data: errorMasivo } = response ?? {};
    return typeof errorMasivo === "string" && errorMasivo.includes("404");
  };
  const userNoRegisteredInMasivo = getUserNoRegisteredInMasivo();

  const { name, lastname, phone, gender } = user ?? {};
  const { document, documentType, email, uid: userUid } = user ?? {};

  // TODO: test if can register user without lastname
  useEffect(() => {
    if (!userNoRegisteredInMasivo) return;
    console.log("Start masivo register");

    if (!userUid) {
      createErrorNotification("Masivo Register: User not found");
      return;
    }

    if (!name) {
      createErrorNotification("Masivo Register: First name is required");
      return;
    }

    if (!lastname) {
      createErrorNotification("Masivo Register: Last name is required");
      return;
    }

    if (!email) {
      createErrorNotification("Masivo Register: Email is required");
      return;
    }

    (async () => {
      try {
        const masivoPayload: MasivoRegisterHookPayload = {
          name,
          lastname,
          phone,
          gender,
          document,
          documentType,
          uid: userUid,
          email
        };
        await handleMasivoRegister(masivoPayload);
        // createSuccessNotification(
        //   "Masivo Register: User registered successfully"
        // );
      } catch (error) {
        const message = getApiMessageError(error);
        const code = getTradeCodeApiError(error, "[TMA]CBU");
        const parseMessage = `${code} - ${message}`;
        createErrorNotification(parseMessage);
      }
    })();
  }, [
    document,
    documentType,
    email,
    gender,
    handleMasivoRegister,
    lastname,
    name,
    phone,
    userNoRegisteredInMasivo,
    userUid
  ]);
};

export default useListenMasivoUser;
